import request from '../request';

export type CardAdditionalFields = {
  id: number;
  card: string;
  campaign: string | null;
  campaignErids: string[] | null;
  externalCampaigns: string[] | null;
  externalCreatives: string[] | null;
};

export type CardAdditionalFieldsUpdateFields = {
  campaign?: string | null;
};

export type PCardAdditionalFieldsUpdate = {
  id: number;
  fields: CardAdditionalFieldsUpdateFields;
};

export type RCardAdditionalFieldsUpdate = CardAdditionalFields;

export const cardAdditionalFieldsUpdate = request<
  RCardAdditionalFieldsUpdate,
  PCardAdditionalFieldsUpdate
>({
  method: 'cardAdditionalFields.update',
});
